import { Factory } from 'fishery'
import { v4 as uuidV4 } from 'uuid'
import { OpalApiComponent } from '@opallabs/api'
import { EMPTY_TO_ONE } from '@opallabs/json-api'

type WorkspaceResourceV3 = OpalApiComponent<'V3', 'workspace'>

export const workspaceResourceFactory: Factory<WorkspaceResourceV3> =
  Factory.define<WorkspaceResourceV3>(({ sequence }) => {
    return {
      id: uuidV4(),
      type: 'workspace',
      attributes: {
        created_at: new Date().toISOString(),
        legacy_id: `${sequence}`,
        name: 'Mock Workspace',
        slug: 'mock-workspace',
        start_of_week: 0,
        timezone: 'America/Los_Angeles',
        updated_at: new Date().toISOString(),
      },
      relationships: {
        logo: EMPTY_TO_ONE,
        workspace_defaults: EMPTY_TO_ONE,
      },
      links: {
        v2_request: `/brands/v2/${sequence}`,
      },
    }
  })
